import api from "api";
import secureLocalStorage from "react-secure-storage";

export function engagementStats(sd,ed,sd1,ed1) {  
if(secureLocalStorage.getItem('id')=='00000000-0000-0000-0000-000000000001'){
  return api.get(`get-engagement-stats/${sd}/${ed}?tab=slot_booking&sd=${sd1}&ed=${ed1}&userId=undefined`);
}
else{
  return api.get(`get-engagement-stats/${sd}/${ed}?tab=slot_booking&sd=${sd1}&ed=${ed1}&userId=${secureLocalStorage.getItem('id')}`);
}
}

export function filterAgent(sd,ed,sd1,ed1, agentId){
  return api.get(`get-engagement-stats/${sd}/${ed}?tab=slot_booking&sd=${sd1}&ed=${ed1}&agent_id=${agentId}&userId=${secureLocalStorage.getItem('id')}`);
}

export function DownloadStats(sd, ed,sd1,ed1,agentId="") {  
  return api.get(`get-engagement-stats-excel/${sd}/${ed}?tab=slot_booking&sd=${sd1}&ed=${ed1}&agent_id=${agentId}`);
}


export function fetchUser() {  
  return api.get("/users")
}


